const s = {
  name: "Shirt",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.9 40" style="enable-background:new 0 0 39.9 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,2c-1.1,0-2,0.9-2,2h-2c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4c0,1.9-1.3,3.4-3,3.9V9h2v2h-6V9h2V6h1
			c1.1,0,2-0.9,2-2C22,2.9,21.1,2,20,2z"/>
		<path class="st0" d="M15,9h-4.4L0,19.5L6.4,26l3.6-3.6V40h20V22.4l3.6,3.6l6.4-6.4L29.4,9H25v1c0,2.8-2.2,5-5,5s-5-2.2-5-5V9z
			 M2.8,19.5l8.5-8.6H13c0.5,3.4,3.4,6,6.9,6s6.4-2.6,6.9-6h1.7l8.6,8.6l-3.6,3.6L28,17.6V38H12V17.6l-5.6,5.6L2.8,19.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Shirt
};
